module.exports = __webpack_public_path__ + "img/CarmelaDorothea.f180a44.png";